import {
  QUERY_RESPONSE_RECEIVED,
  MUTATION_RESPONSE_RECEIVED,
} from '@web-platform/shared-universal-constants/src/network';
import {
  SONAR_V3_ALPHA_CREATE_SESSION,
  SONAR_V3_CREATE_SESSION,
  SONAR_V3_POLL,
  SONAR_V3_POLL_ALPHA,
} from '@web-platform/shared-universal-types/src/network/requestTypes';
import { isSonarV3ErrorPayload } from '@web-platform/shared-universal-utils-frontend/src/helpers/isSonarErrorPayload';
import keyBy from 'lodash/keyBy';

import { isEmptyItinerary, isNullishItinerary } from '../utils';

import { mapSonarV3Carriers } from './sonarV3CarriersMapper';

import type {
  MutationAction,
  MutationResponseAction,
  QueryAction,
  QueryResponseAction,
} from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type {
  CarrierStateBookingPanel,
  CarrierBookingPanel,
} from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/entities/flights/carriersBookingPanel';

export const INITIAL_STATE: CarrierStateBookingPanel = {
  byId: {},
};

const byId = (
  state: Record<number, CarrierBookingPanel>,
  action: MutationResponseAction | QueryResponseAction,
) => {
  switch (action.payload.type) {
    case SONAR_V3_ALPHA_CREATE_SESSION:
    case SONAR_V3_CREATE_SESSION:
    case SONAR_V3_POLL_ALPHA:
    case SONAR_V3_POLL: {
      if (isSonarV3ErrorPayload(action.payload.response)) {
        return state;
      }

      if (
        isEmptyItinerary(action.payload.response) ||
        isNullishItinerary(action.payload.response)
      ) {
        return state;
      }
      return {
        ...state,
        ...keyBy(
          mapSonarV3Carriers(
            action.payload.response.body.itinerary?.legs,
            state,
            action.payload.response.body.itineraryLegacyInfo?.carrierLogos,
          ),
          (carrier) => carrier.id,
        ),
      };
    }

    default:
      return state;
  }
};

const carriersReducer = (
  state: CarrierStateBookingPanel = INITIAL_STATE,
  action: MutationAction | QueryAction,
): CarrierStateBookingPanel => {
  switch (action.type) {
    case MUTATION_RESPONSE_RECEIVED:
    case QUERY_RESPONSE_RECEIVED: {
      const newById = byId(state.byId, action);
      if (newById === state.byId) return state;
      return { byId: newById };
    }

    default:
      return state;
  }
};

export default carriersReducer;
